import { render, staticRenderFns } from "./Tigan.vue?vue&type=template&id=80744e34&scoped=true"
import script from "./Tigan.vue?vue&type=script&lang=js"
export * from "./Tigan.vue?vue&type=script&lang=js"
import style0 from "./Tigan.vue?vue&type=style&index=0&id=80744e34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80744e34",
  null
  
)

export default component.exports